import jwtDecode from "jwt-decode";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

const checkTokenExpirationMiddleware = (store) => (next) => (action) => {
  const token =
    JSON.parse(localStorage.getItem("user")) &&
    JSON.parse(localStorage.getItem("user"))["accessToken"];

  if (
    store.getState().auth.isAuth === true &&
    token &&
    jwtDecode(token).exp < Date.now() / 1000
  ) {
    localStorage.removeItem("user");
    store.getState().auth.isAuth = false;
    window.location.reload();
  } else {
    return next(action);
  }
};

export default checkTokenExpirationMiddleware;
